module.exports = __webpack_public_path__ + "static/media/and_scr_onboarding_03_a.f42eaeca.png";